// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + "styles" + "." + "bc4e146f3de2a1d1faf7" + ".bundle.css";
};